import React from 'react'

import NavigationMenuItemInputCommon from "./menu-item-add-common"
import {ProjectIconDictionary} from "../../../../../core/gd/const/project"
import quickAdd_createWhiteboard
    from "../../../../../app/quick-add/sections/structure/whiteboard/helpers/create-whiteboard";

type Props = {
    level?      : number
    parentId?   : ID
    onAdded     : {(isAdded:boolean):void}
}

// const debug = "NavigationMenuItemAddWhiteboard"
const debug = false

export default function NavigationMenuItemAddWhiteboard(props: Props) {

    const projectIcon = 'whiteboard'

    const onCommit = async (value?: string) => {
        // do nothing if no title
        if (!value) {
            props.onAdded(false)
            return
        }

        debug && console.log(debug, 'onChange', value)

        props.onAdded(true)

        let project = await quickAdd_createWhiteboard({
                company         : gd.companyId,
                parentProject   : props.parentId,
                name            : value,
                owner           : gd.user.id,
                color           : gd.session.projects.get(props.parentId)?.color,
            })

        gd.goTo(project!.url)
    }

    return (
        <NavigationMenuItemInputCommon iconClass  = {ProjectIconDictionary[projectIcon]}
                                       level      = {props.level}
                                       parentId   = {props.parentId}
                                       onCommit   = {onCommit}/>
    )
}
